<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M27.66 12.25A3 3 0 0025.23 11h-4.45l1.08-4.32a3 3 0 00-5.25-2.47l-5 6.79H5.18a2 2 0 00-1.53.71 2 2 0 00-.44 1.62l1.66 10a2 2 0 002 1.67H10a2 2 0 002-1.64l1.59.94a5 5 0 002.54.7h6.47a3 3 0 002.8-2l2.67-8a3 3 0 00-.41-2.75zM10 23H6.85L5.18 13H10zm16.17-8.68l-2.66 8a1 1 0 01-1 .68h-6.42a2.93 2.93 0 01-1.52-.42L12 21.06v-7.19l6.22-8.48a1 1 0 011.53 0 1 1 0 01.17.82L18.22 13h7a1 1 0 01.81.42 1 1 0 01.14.9z"/></svg>